var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkyline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2610.69 1058.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gound_Line",
    "data-name": "Gound Line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,798.58C37.91,827,30,834.43,51.4,859.07c11.3,13,26.65,21,37.75,34.57,9,11,14.37,24.83,25.1,34.37,27.71,24.64,54.86-13.38,106.19,34.64,12.51,11.71,34.22,43.71,51.16,43.7,13.53,0,28.41-5.34,39.89-5.34,14.75,0,25.53,6.4,38.77,6.59h.49c8.93,0,18.25-3.09,27.13-3.09,14,0,25.81,9.77,39.77,9.77,18.4,0,33.69-12.15,54.08-12.15,31.44,0,52.81,27.51,101,27.51,21.64,0,43.39-7.09,64.94-7.1,36.94,0,52.12,22,99.63,22,63.54,0,90.63-25.24,138.81-33.92,94.34-17,144-54.79,215.12-63.14,23.32-2.73,414.41-4.76,516.46-4.77,48.22,0,133.61-.92,145.85-.92,175.08,0,95.47-127.06,261.31-127.08,27.81,0,166.67,10.18,194.46,10.18,90.14,0,161.73-58.45,259.36-58.46l133.06,0",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Umbrella_2",
    "data-name": "Umbrella 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M556.09,995.59q-.15,16.44-.33,32.87",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M584,995.52c-2.45-8.74-6.47-20.66-27.77-20.66-14.84,0-22.9,8.25-27.51,20,9.67.39,19.46.68,29.23.68Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.19,974.86c-12.13,4.84-18.37,12.06-21.46,20.28",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.19,974.86c-5.79,3.62-9.46,19.11-9.42,20.62",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.65,974.49c.09-3,1-4.34,1.84-4.34,1.6,0,1.62,3.83,1.6,4.11",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.5,974.94c12.13,4.84,17.74,11.81,20.84,20",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556,974.94c5.79,3.62,9.35,18.86,9.31,20.36",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Umbrella1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M718.74,1011.37c-3-11.07-7.93-26.18-34-26.18-18.17,0-28,10.45-33.69,25.41,11.84.49,23.82.86,35.79.86Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.74,985.19c-14.86,6.13-22.49,15.29-26.29,25.7",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.74,985.19c-7.09,4.59-11.59,24.22-11.54,26.12",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.85,984.72c.1-3.85,1.2-5.51,2.25-5.51,2,0,2,4.86,2,5.22",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.62,1011.46q-.21,22.85-.45,45.69",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.11,985.3c14.86,6.13,21.73,15,25.53,25.37",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.49,985.29c7.09,4.59,11.45,23.9,11.4,25.81",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Wave_1",
    "data-name": "Wave 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2123.26,762.54c11.12-2.38,22-4.21,33.27-4.21,14.8,0,26.52,3.6,40,3.6,23.4,0,35.05-14.39,54.42-14.39,22.45,0,39.39,15,59.69,15,10.07,0,24.56-6.72,36.83-14",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wave_2",
    "data-name": "Wave 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2194.13,591.32a119.06,119.06,0,0,1,26-3.29c18,0,34,7.22,54.6,7.22,19,0,36.38-9.41,55.37-9.43h.07c20.58,0,38.79,11,59.14,11.47",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wave_3",
    "data-name": "Wave 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1674.14,783.83c41.93,5,56.89-10,86.17-10,19,0,33.19,11,52,11,24.25,0,34.29-21,60.46-21,12,0,23.87,2.93,35.83,5.68",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wave_4",
    "data-name": "Wave 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1569,556.26c43,2.48,36.8,12.27,52.66,12.26,16.1,0,23.52-10.23,45.53-10.23,33,0,45.86,14.48,70.87,14.48,29.94,0,31.51-17,61.69-17,33.08,0,25.16,14.31,65.56,11.77,16.15-1,29.21-19.43,46.79-19.43,22.43,0,35.05,19.61,57.59,19.61h3.37",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Water_Lady",
    "data-name": "Water Lady"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Torso"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.32,877.77c.27-10,.32-38.57,8.23-44.55",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.75,877.6s5.34,3.83,15.31,4.65c6.79.56,23.93-4,28.9-4.92",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.2,877.81c-2.17,3.74-7,13.46-7,17.78,0,1,7.22,22.63,8,24.68",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,939.84c-15.47-2.93-21.88-31.61-24.14-24.65",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,939.84c11.71-23.32,29.75-14.76,32.17-19.57",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.06,829.08c2.77,5.09,10.43,3.11,14.31,6.06",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.7,844.34c-1.76,5.21-6.39,16.36-6.39,21.78,0,10.19,13.23,25.56,7.78,29.48-7.28,5.22-12.67,13.82-15.19,19.59",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Left_Arm",
    "data-name": "Left Arm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,798.58c73.13,7.84,42.12,23.75,71.93,23.75,10.65,0,20.83-3.35,31.55-3.35,51.3,0,61,44.19,100.41,44.19,17,0,29.05-7.5,36.51-7.51,11,0,23.32,11.71,64.27,13.83",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.56,872.47c-2.55,3.58-11.17,9.33-16.43,20.17-7.23,14.89-27.66,39.56-27.66,39.56",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.46,929.26c7-19.64,20.3-39.63,20.3-39.63,7.74-13.3,24.4-37.56,33-46.17",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.47,932.2c-1.65,5.85-5.19,16.89-8.08,22.29a10.56,10.56,0,0,1-.47-3.27c0-2.8.79-5.76.93-8.47-2.89,4.37-5.14,9.09-7.78,13.6a9.39,9.39,0,0,1-.3-2.42c0-3.13,1.33-6.37,2.33-9.25-1.34,3.47-2.3,7.45-5,10.17a4.58,4.58,0,0,1-.36-1.89c0-2.9,2-6.46,2.79-8.84-1.66,3-2.78,6.3-4.8,9a4.36,4.36,0,0,1-.39-1.93c0-2.57,1.56-5.7,2.58-7.61a28.82,28.82,0,0,0-2.83,4.47c2.82-6.75,6.33-13.68,14.33-18.81",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right_Arm",
    "data-name": "Right Arm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370,858.39c.24,46.45-.51,39.33,43.09,53.88",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M446.31,915.66a5,5,0,0,1-1.67,3.15c-3.39,3.18-10.95,4.23-14.35,3.9a15.63,15.63,0,0,1-4.81-1.24c-6.48-2.85-5.64-6.13-12.43-9.2",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.13,913.69c-.25.28-.52.56-.8.82-3.9,3.67-10.36,5.94-15.64,5.15",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.82,903.76c7.61,2.56,18.47,2.15,26,4.55-3.39,2.88-8.14,1.29-12.09,1.93,4.82,2.1,12,1.76,17.34,2.11l-.28.28c-3.88,3.65-11,3.68-16,3.27",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.49,835.19c14,5,7.34,46.76,9.7,50.14,5.61,8,17.15,13.32,29.63,18.43",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "left_leg",
    "data-name": "left leg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.9,915.19c-4.11,6.73-1.11,24.08-1.11,24.07-1.26,7.46-2.75,6.44-4.42,14.14-8,36.71-15,46.81-20.86,51",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.21,941.2c-2.53,17.89-13.66,45.76-22.6,60",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "right_leg",
    "data-name": "right leg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.21,920.27c7.52,25.42,10.8,42.36,0,84.73",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,939.84c3.61,18.43,19.38,23.53,19.38,42.16,0,6.74-8.38,18.85-8.57,25.59",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.82,804.61a12.11,12.11,0,0,0,5.36-1.37",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.55,799.5c0,.32.05.64.05,1,0,.09-2.25,22.16-9.21,22.16-.68,0-9.33,0-10,.3",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.84,849c17.08,0,15.56-11,15.45-11.51,5-3,7.28-6.84,6.9-11.15a15.68,15.68,0,0,0-3.3-7.85c17-2.28,9.94-14.55,9.22-16,11,1.69,21.83-8.39,7.52-18.43-6.24-4.39-18.92-3.44-21.88.36-2.79-.1-12.84-3.27-17.33,8.32-7.91,1.08-10.42,5.76-9.76,13.49v0c-13.2,1.57-10.32,16.29-6.39,18a15.62,15.62,0,0,0-2.93,9.8c.5,5.82,4.49,8.92,10.35,10.23,2,3.95,11.53,4.8,12.14,4.67",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Man_in_Water",
    "data-name": "Man in Water"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.12,835.11c-.36,1.55-.63,3.14-.86,4.72",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,831.86a66.08,66.08,0,0,1-1.64,8.5",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.7,861.06c7-7.83,18.5-21.93,41.66-21.93,16.45,0,22,9.59,31.2,23.06",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.08,805.49c-2.17-3.08-4-7.83-11.23-7.83-13.34,0-16.43,16.06-16.42,29.35,0,3.16,1,6.37,6.25,6.37,4.85,0,7.21-5.87,8.82-10.13",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,813.15c2,8.18,5.23,6,5.23,8.42,0,1.72-3,1.71-4.06,1.71h-.88",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.47,811.35c-.22,3.91-.48,5.51-3.17,5.51a12.25,12.25,0,0,1-2.05-.21A3.28,3.28,0,0,0,232,819c0,1.77,2,3.23,4.24,3.23h.13a7.45,7.45,0,0,1,.52,3c0,1.39-.21,2.83-.21,4.24,0,2.86,1.13,5.67,4,5.67,7.39,0,9.46-9.78,9.46-17.19,0-9-.18-11.29-2.4-12.39-.94.46-2.74,3.58-4,3.58-1.79,0-1.42-4.14-3.64-4.14-1.51,0-1.73,2.19-1.73,4.07,0,.74,0,1.44,0,1.93C238.48,811.14,238.48,811.25,238.47,811.35Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Duck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1730.74,871.38c2.11.14,4.16.22,6.18.22,8,0,15.39-1.27,22.88-5.26",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.06,881.27c11.66-3.53,24.56-7.32,24.56-26.76,0-.35,0-.69,0-1,4.63-2.26,10.42-3.47,15.27-5.17-4.76-.55-9.43-1.51-14.17-2.24-1-3.74-1.75-11.19-12.7-11.19-20.88,0-8.18,27.94-39.55,27.94-9.47,0-19.64-2.76-25.43-6.32,5.27,11.74,16.21,23.92,30.07,24.32",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Duck_eye",
    "data-name": "Duck eye"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1774.69,842.75a1.9,1.9,0,0,0-.59-.11,2,2,0,0,0-1.73,2.17,2.21,2.21,0,0,0,2.21,2.26,1.81,1.81,0,0,0,1.67-2A2.38,2.38,0,0,0,1774.69,842.75Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Duck_Wave",
    "data-name": "Duck Wave"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1692.14,889.66c6.65-5.34,16,0,19.64,0,14.54,0,21.28-10.68,34.13-10.69,9.61,0,18.38,5.75,28,5.75,8.3,0,15.46-4.46,23.77-4.46,9.56,0,16.49,6.47,26,6.47,9.65,0,16.93-5.42,26.34-5.42",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Long_wave",
    "data-name": "Long wave"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1675.64,738.09c22-13.37,47.48-29,74.07-29s36.84,17.27,58.24,17.26c19.28,0,28.58-17.84,47.71-17.85,14.19,0,26.95,8.81,41,8.81,19.31,0,23.83-18.14,40-18.14,19.53,0,33.39,20.26,55.47,20.25,23,0,37.73-21.09,60.89-21.09,22.75,0,37.31,17.61,63,17.61,34,0,63.57-29.9,95.17-29.91,18,0,36.81,10.56,55.81,10.56,16.5,0,30.9-6.36,47.73-6.36,9.7,0,31.05,2,32.08,2,28.61,0,46.13-31.74,99.11-31.75",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Water_Face",
    "data-name": "Water Face"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1991.84,621a54.53,54.53,0,0,1,1.39,11.08c0,9.52-4.41,14.14-13.16,22.88",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2118.41,617.12q.18,2,.18,3.9c0,11-4.39,20-13.28,28.81",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2019.55,608.3c22.21-8.44,22.15-22.88,36-22.88,5.87,0,7.46,8,7.47,13.85a76.69,76.69,0,0,1-.68,9.14",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.64,620.41c6.38,7.64,7.32,15.73,7.32,23.6,0,3.31-.16,6.59-.16,9.77,0,23.17,16.44,29.87,39.73,29.86,10.48,0,21.13-1.25,29.54-1.25h.06c61.92,0,88.06,8.74,97.6,28",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2179.18,694.2a89.64,89.64,0,0,0,2.24-19.72c0-50.61-81.78-66.42-132.35-66.41-114.2,0-210.58,7.47-210.56,105.39",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sea_Line",
    "data-name": "Sea Line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,798.58c41.06-20,20.9-40,130.69-40,68.46,0,87.06,10.17,134.92,10.16s71.42-23,111.44-23c24.42,0,47.88,14.11,67,26.42",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lighthousse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.12,737a5.22,5.22,0,0,1,1-2.2l1,.54a16.91,16.91,0,0,1,.61,4,4,4,0,0,1-1.44,3.49c-.31-.09-.61-.21-.92-.28a13.39,13.39,0,0,1-.5-3.5A8.53,8.53,0,0,1,70.12,737Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.84,687.14a.45.45,0,0,0-.5-.29h-.49A6.88,6.88,0,0,0,90,690.3a16.94,16.94,0,0,0,.38,3.22c1.58-.06,2.08-1.44,2.08-3A9.88,9.88,0,0,0,91.84,687.14Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.44,663.62A24.22,24.22,0,0,0,87,669c0,.73,0,1.46,0,2.17v.14",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,663.19c-.06,1-.08,2-.08,3,0,2,.08,4,.08,6",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.64,662.85a8.6,8.6,0,0,1,0,2.17c0,2.42-.19,5.79-.19,7.26v.16",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.27,663c10.66,0-.72,0,10.66,0",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.93,671.75c0-3.48.29-10.73-.06-14.2-1.57,0-3.67.37-4.09.32l.11-3.31H82c0,.06-.12,3.3-.12,3.3l-4.34.12c0,2.95-.12,10.84,0,13.77",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.83,679.21V673c4-.48,20-.45,20-.45l-.13,7.13",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.42,742.24c.25,3.13.4,13.29.59,16.43",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.11,730.11c3.49,1.62,14.28,8.82,17.4,11.94",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15,742.17c.64,0,1.29,0,1.94,0,2.93,0,5.94.17,8.88.17,1.36,0,2.7,0,4-.15",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.23,763.77c2.64-10.09,9.17-75.22,10.57-83.3,0,0,16.64-.68,24.17-.68.91,6.63,11.41,85.15,10.33,77.58",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Light"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 292.35,
    y1: 667.16,
    x2: 89.93,
    y2: 671.75,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.93,663c84.19-63.31,165-109.36,248.07-174.09",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Wave_Line_Beach",
    "data-name": "Wave Line Beach"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389,887.59c34.32-12.13,75.47-30.25,106.36-30.26,48.16,0,43.11,31.29,88.6,31.28,31.44,0,64.34-16.18,95-16.18,58.16,0,162.74,70.31,245.92,70.3,98.84,0,91.59-58.22,416.11-188",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Door_Line",
    "data-name": "Door Line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1340.66,748.58l-117.3-62.3c-24.43.86-81,1.85-81,1.85l-.25,91.13-180.28-1-2,160.49",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.37,753.46a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.28,732.64a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.71,744.35a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.69,775.15a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.31,704.89a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.38,755.2a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.75,731.35a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.23,702.73a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.38,748.45V748a1.37,1.37,0,0,0-.17-.72,1.59,1.59,0,0,0-1-1,1.47,1.47,0,0,0-.72-.17l-.5.07a1.93,1.93,0,0,0-.83.48l-.29.38a1.88,1.88,0,0,0-.25.95v.43a1.42,1.42,0,0,0,.16.73,1.37,1.37,0,0,0,.38.6,1.52,1.52,0,0,0,.61.39,1.46,1.46,0,0,0,.72.16l.5-.07a1.93,1.93,0,0,0,.83-.48l.29-.38a2,2,0,0,0,.26-.95Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.51,790.34a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.21,791.21a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.23,828.08a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.72,818.11a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.82,796.86a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.69,849.34a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042,820.72a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019,796.86a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.2,851.08a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.43,817.25a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.58,895.76a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.07,877.1a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996,914a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Door"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1089.42,776.83c-.65-27.6-1.85-55.07-1.85-82.63,0-8.13.1-16.27.35-24.43-13.7-.11-27.35-.79-41-.79-17.79,0-26.24,1.38-41.58,2.18-.82,26.27-1.82,52.27-1.82,78.38,0,9.41.13,18.82.45,28.27",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.58,777c-.58-19.85-1.86-37-1.86-58.45,0-10.74.22-34.21.22-35.21-7.86-.43-15.72-.56-23.58-.56-11.81,0-23.63.3-35.44.33q0,47.29.11,94.59",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.94,683.72c4.29-4.53,8.54-9.07,13-13.48",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.3,671.16c3.45,4.56,7,8.14,10.62,12.61",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.47,728a4.11,4.11,0,0,0-1.19-.23c-1.56,0-3.47,1.8-3.47,4.42a4.15,4.15,0,0,0,4.23,4.35c2.26,0,3.47-2,3.47-4.08A4.53,4.53,0,0,0,1061.47,728Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060,736.94a17.68,17.68,0,0,0-.32,4.22c0,2-.18,7.23,1.63,7.23,2.4,0,2.56-7.67,2.56-10,0-.83,0-1.67,0-2.49,0-.27,0-.53,0-.79",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rain_Cloud",
    "data-name": "Rain Cloud"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.82,261.72c0-24.45,24.12-20.38,34.22-21,3.42-10.21,7.53-14.23,15.48-14.13a42.42,42.42,0,0,1,9.13,1.34c3.27-15.49,13.21-22.7,25.65-22.54s23.63,7,26.22,24.29c5-4.9,11.63-6.85,18.09-7a22.89,22.89,0,0,1,23.83,21.44c1.17-.14,22.6.7,22.3,18.3-.16,9.8-7.06,12.82-24.51,12.6-9.06-.11-137.35-.27-137.35-.27S451.82,275,451.82,261.72Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2091.2,49.74c0-13.17,13-11,18.44-11.33,1.85-5.5,4.06-7.67,8.35-7.61a22.61,22.61,0,0,1,4.92.72c1.76-8.35,7.12-12.23,13.82-12.15s12.74,3.77,14.13,13.09a14.28,14.28,0,0,1,9.75-3.79,12.35,12.35,0,0,1,12.85,11.56c.62-.08,12.18.37,12,9.86-.09,5.28-3.81,6.91-13.22,6.79-4.88-.06-74-.15-74-.15S2091.2,56.89,2091.2,49.74Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.82,275c-15.18,19.5-20.61,22.65-24.54,43.36-7.88,41.49,37.91,73.54,37.92,105.18,0,36.53-50.94,46.3-50.94,81.32,0,24.25,24.08,42.25,6,66-5.56,7.29-12.87,13-19,19.88-15.24,17-14.54,45-15.45,66.78-.93,22.29-.77,44.62-.18,66.92.25,9.08.56,18.17,1,27.25",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.64,274.77c-16.5,17.46-33,36-33,58.74,0,35.34,29.55,50.37,29.55,79.06,0,41.5-59.24,43.25-59.24,88.49,0,22.81,13.5,37.1,13.5,49.45,0,24.42-32.82,10.78-36.55,59.38L446.31,867",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "City_Lines",
    "data-name": "City Lines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.54,740.61a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.18,731.92a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.06,716.32a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.31,703.27a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.56,743.86a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.41,703.26a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.18,709.35a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.31,737.9a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.28,689c.43,10.41.63,20.89.63,31.37,0,10.93-.21,21.86-.62,32.71",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677,688.34c.09,5.29-.09,20.94.08,26.09",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.86,688c38.45.31,76.92,1,115.38,1,28.78,0,57.55-.43,86.29-1.77",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.21,688.26c0,1.63,0,3.27,0,4.91,0,14.18.16,28.41.16,42.62q0,8.06-.08,16.09",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.26,751.48c-1.82-28.76.12-57.63-2.94-86.27l-.07-.06c24.87-1.28,49.74-1.65,74.6-1.65,32.66,0,65.32.62,98,.61q15.35,0,30.7-.22",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.67,751.66c52,.56,112.81,1.67,164.77,1.67q17,0,34-.25s-.56-38.67-.15-38.67l29.25-.23s-1-168.55-1-227.22c0,0-27.18,13-32.33-9.11-3-13,14.74-21.69,14.74-21.69s-18.17.46-17.35-11.71c.84-12.59,12.68-14.46,12.68-14.46s-15.59-7-6.54-20.47c9.36-13.91,21.31-6.5,21.31-6.5s1.42-19.41,20-19.41c7.92,0,15.71,6,18.67,18.64,2-.33,19.31-7.26,23.65,10.71,3,12.58-9.07,19-9.07,19s12.59.82,11.29,18.6c-1,14.07-11.27,15.62-11.27,15.62s9.32,11.12-.87,20.39C741.16,495,725.3,490,725.3,490c-1.2,31.24-1.67,40.51-1.66,71.79,0,37.57,2.06,63.82,3,101.35h37.27V677h13.45l0,37.38h36.9c-.14,42.91-1.33,93.65-1.32,136.49,46.7.23,100.49-2.23,147.42-1.32",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.67,521.83l39.07-.18c.09-8.4.14-16.81.25-25.21,13.14.26,26.26.71,39.4.71h1.29c.29,7.37.3,14.73.66,22.1,9.32-.6,18.65-1,28-1.24q-.14,6.53-.14,13c0,5.17.07,10.33.25,15.49,10.71.19,14.5.85,25.26.85",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.39,622.4c.49-.8,1-1.59,1.47-2.4a10.85,10.85,0,0,1,4.3,0",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.45,623.1H641c-6.11,0-8.85-.89-8.85-7.79v-.22",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583,614.17a60.11,60.11,0,0,1,.55,9.06c0,12.5-2,30.06-3.32,39.92",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.27,663c9.72-45.12,1.22-62.79,30.66-60.84,20.73,1.37-11.78,8.92,57.65,13.52a19.08,19.08,0,0,1,.9,5.87c0,9.43-3.94,20.78-15.84,20.79-6,0-12.95-2.14-19.71-2.14-18.67,0-21,6.82-23.08,23.28",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.52,664.06c-.07-4.21,0-73.24,0-73.25-31.83.5-113.29,1-118.91.83.17,3.82-.76,51.85-1.1,72.11",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.41,620.33a28.54,28.54,0,0,0,4,.32c3.41,0,5.61-1.1,9.29-3.75",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tower"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.73,450.47c-.09,17.71-1,36.71-1,54.4q0,15.35.13,30.69",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.35,667.16c-.6-19.14-1-38.27-1-57.41,0-21,.41-41.94,1.34-62.92,0,0,22.14-.26,24.55-.24.31-3.73.77-11.19.77-11.19,10.92.37,38,0,38,0l.14,9.82c8.53-.33,18-.92,26.52-1.37,0,16.52.58,33,.58,49.53,0,3.8,0,67.6-.09,71.4",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.71,764.94V743.06H232v-17.8h11V700.51h15.91V683.05h16.2V667.51c21.89-1.08,167.78,0,167.78,0",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Coffee_Element",
    "data-name": "Coffee Element"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1152.45,445.32c3.11-.83,8.1-2.35,10.77-2.35,8.71,0,13.75,4.9,13.75,15,0,20.65-15.18,44-28.94,62C1152.62,494,1153,466.32,1152.45,445.32Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clock_tower",
    "data-name": "Clock tower"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1897.81,406.62q.11-28.86,1.21-57.73c-26.43,0-94.94.55-97.72.31l.22,55.57",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1889.74,348.9c-.27-20.48-.41-84.49-.08-97.73,0,0-53.67-.8-80.13.29-.13,32.59-.69,65.21-.78,97.8",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1868,251c0,20.09-.06,40.18-.06,60.26q0,18.87.12,37.74",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850.25,250.89c-.19,28.69-.48,57.34-.47,86q0,6.07,0,12.16",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1831,251c-.17,7.56-.23,15.11-.22,22.65,0,10.3.09,20.6.1,31,0,18.65-.37,29.35-.41,44.6",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.07,251.05c0-22,.81-43.93.81-65.89q0-6.32-.1-12.64c-5.55.22-11,.31-16.53.31-13,0-25.83-.52-39-1.17-.14,6.36-.19,12.71-.19,19.05,0,20.13.59,40.22,1.06,60.35",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.78,172.52c-6.34-25.76-25-81.83-25-81.83s-19.76,56.24-30.51,81",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1849.24,
    cy: 206.64,
    r: 17.06,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1849.58,195.08v11.56",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845,203c1.49,1.33,2.9,2.8,4.41,4.14",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.62,117.15a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1858.25,128.42a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1847.55,132.18a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.62,144.9a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.89,147.22a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1849.57,156.76a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.25,164.27a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1861.43,156.76a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1848.71,167.75a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1866.64,168.61a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Flower_Line",
    "data-name": "Flower Line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M863.16,847.53v-3.88c0-30.87-.49-61.78-.49-92.65,0-59.76,2.88-168.81,2.88-168.81l198.07-1c-35.13-31.66-26.94-139.83-25.61-162.21,21.21-1.56,109.76-2.28,111.9-2.39,1.48,2.49.59,7.57,1.34,12.85,4.76-1.82,11.14-3.68,15.09-3.68,14.89,0,23.77,12.13,23.77,30.35,0,36.2-26.36,69.48-48.48,92.8-4,14.45-8.89,26.12-14.38,32.21l78.21-.62c-1.12,65.18-.37,105.61-.37,105.61",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M813.84,757.37q12.58.5,25.2.48c7.88,0,15.76-.14,23.63-.37",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.73,757.75c.06,14.71.16,29.43.17,44.15,0,12.15,0,30.29-.45,48.41",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.75,757.85c.75,27.77,1.79,59.53,2.29,91.31",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.27,757.73q-1.11,42.71-1.06,85.38c0,1.3,0,4.59,0,5.88",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lady_on_Roof",
    "data-name": "Lady on Roof"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M899.29,447.14c-4.8,4.08-5.74,13-5.74,19.17,0,5.49.41,11.1,6,11.1,3.93,0,16.37-8.05,18.46-9.78",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 904.11,
    y1: 475.97,
    x2: 904.11,
    y2: 485.36,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916,469.33c.14,5.07.08,11.71.75,16.73",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916,469.33c.62-2,1.91-5.75,1.91-8.83,0-3.55-1.64-4.92-4.8-4.92-1.88,0-3.81.51-5.67.51-6.3,0-6.72-5.33-8.13-8.95,11.72-9.64,24.51,1.21,24.51,9.27C923.8,456.41,923.8,466.79,916,469.33Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.67,470.78a14.78,14.78,0,0,0,4.61-.89",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.06,460.49a6.72,6.72,0,0,0,4.09,1.26,9,9,0,0,0,1.72-.17",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.46,581.6C918,575,920,566,920,545c0-29.12-4-34.42-4-43.86a46.19,46.19,0,0,1,2.44-13.82,22,22,0,0,0-9.88-2.39c-16.74,0-12.24,15.74-15.36,19.81-2.92,3.82-10.76,1-10.75,7.42,0,5,5.75,5.31,5.75,14.26,0,9.56-2.78,20-4.25,29.22a73.91,73.91,0,0,0-7.73-.44c-22.79,0-31.28,12.77-43.93,32.48,4.23,5.1,11.56,24,31.68,26.48",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.41,606.24c-13.58,21.21-17.64,39-24.28,39-4.3,0-13.25-6.07-16.55-6.06-2.6,0-3.88,2.58-3.87,5,0,3.78,6.07,8.69,12.26,12.57,2.2,0,4-.48,5.42-.48,2.08,0,3.32,1,3.7,5.49a16.42,16.42,0,0,0,3.76,1.43l.07-.07.22,0c.07-.06,19.69-26.76,34.14-49.42",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M863.15,665.18c-.9,0-2.34.07-4.09.1-.89-2.24-1.94-3.3-3-3.3s-2.4,1.19-3.57,3.43c-5.55.09-11.44.17-13.68.17-4.46,0-8.91-1.22-9.59-5.2",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.55,655.7c5.77-.65,14.59,1.94,17.83-6.26,1.41-3.57.57-11.33.08-19.32",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M908.05,499.62a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.06,577.41a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.08,560.93a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.56,545a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.25,568.45a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896,536.65a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.67,583.76l-.29.29a1.49,1.49,0,0,0-.39.6,1.7,1.7,0,0,0,0,1.44,1.46,1.46,0,0,0,.39.61l.38.29a1.85,1.85,0,0,0,.94.26l.5-.07a1.87,1.87,0,0,0,.83-.48l.29-.29a1.49,1.49,0,0,0,.39-.6,1.53,1.53,0,0,0,.16-.73,1.46,1.46,0,0,0-.16-.72,1.49,1.49,0,0,0-.39-.6l-.38-.3a1.85,1.85,0,0,0-1-.25l-.5.06a1.82,1.82,0,0,0-.82.49Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859,577.68l-.29.29a1.46,1.46,0,0,0-.39.61,1.7,1.7,0,0,0,0,1.44,1.49,1.49,0,0,0,.39.6l.38.3a1.85,1.85,0,0,0,.95.25l.49-.06a1.8,1.8,0,0,0,.83-.49l.29-.29a1.49,1.49,0,0,0,.39-.6,1.7,1.7,0,0,0,0-1.44,1.46,1.46,0,0,0-.39-.61l-.38-.29a1.86,1.86,0,0,0-.95-.26l-.49.07a1.87,1.87,0,0,0-.83.48Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.3,603.15a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.73,445.59a12.56,12.56,0,0,1,6.91-2.3c5,0,8.91,3.63,15.26,3.63,10.23,0,15.48-9,23.66-9,5.34,0,10.06,4.22,10.06,10.74,0,9.72-8.37,13.74-18,13.74-10,0-23.3-12.24-33-12.23",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.6,612.51a25.45,25.45,0,0,0,12.34,10.93",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.82,626.61a11.17,11.17,0,0,0,3.83.65,19.09,19.09,0,0,0,7.86-2",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918,487.59c14.16.12,7.89,25.13,46.42,86.1,2.64,0,5.58-.16,8.56-.16,5.13,0,15.7.42,15.7,5.57,0,3.11-5.84,2.84-9.93,2.84-6.6,0-15.17-.51-19.85-.51-.79,0-1.47,0-2,.05-7-9.16-5.14-9.93-38.79-68.41",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.85,536c9.46,15.42,19,28.75,28.71,44",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.41,517c1,2.85,3,4,5.21,4a9.15,9.15,0,0,0,5.69-2.31",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Boat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2601.7,766.44c4.59-5.67,7.74-12,8-20.57-23.32-.09-45.3-1.27-67.57-1.26-4.81,0-111.7-1.38-126.31-1,5.67,9.88,11.27,16.37,18.4,25.19",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Boat_Sails",
    "data-name": "Boat Sails"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2502.53,504.86c2.42-.22-79.45,223.31-86.72,238.78",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2425,720.33c5.47.78,36.47-1.31,41.89-1.31,16.27,0,26.59-1.69,29.05-1.57",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mountain_Line",
    "data-name": "Mountain Line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1677,367.25c53.39,0,88.7-29.44,131.94-51.86",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1889.47,291c4.67-.35,9.56-1.37,14.45-.53,84.75,14.53,106.89,44.38,167.14,46.48,49,1.71,57.32-25.66,68.11-32.4,18.9-11.8,24.14,34.17,39.22,34.17,5.16,0,12.08-5.67,17.1-5.67,13.06,0,15.92,26.71,31.62,26.71,10.08,0,12.4-14.11,16.9-20.74,5.58-8.22,15.9-7,23-12.6,5.57-4.42,8.55-15,16.92-15,15.81,0,19.84,30.93,40.11,32.41.37,0,19-3,25.43-3,15.81,0,23.41,22.13,46.15,43.36,26.27,24.54,98.13,109.78,106.93,120.79",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2124.96 320.37 2127.24 323.38 2135.97 316.83 2140.74 323.38 2146.69 316.83 2149.47 323.38 2154.63 316.83 2157.01 323.38 2160.93 318.47",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2269.14 324.26 2273.25 330.32 2279.6 324.75 2282.78 330.32 2288.33 323.18 2290.72 330.32 2295.48 324.75 2299.45 330.32 2301.85 326.35",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mountain_Runner",
    "data-name": "Mountain Runner"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2068.62,225.43c1,26.43-3.46,92.78-3.46,92.78h20.15s-.11-82.77-1.43-108.14",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2082.38,146c-1.06-.7-1.39-.11-2.8-.11-2.21,0-7.12,0-9.13,1.29-7.48,4.69-10.59,19.87-11.23,32.36-.27,5.25-1.63,14.6-1.63,22.35,0,4,.36,7.59,1.43,10,8.8-.42,23.93.38,30.78-4.22a93.3,93.3,0,0,1-1-14.89c0-6.34.35-12.75.35-19.08,0-1.85,0-4-.12-6.22",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070.45,147.21c2.44-4.09,1.68-14,1.56-17.35-.11-2.91-1.93-5.6-2-8.46-.21-5.43,6-8.66,11.85-8.88,7.53-.28,12.48,3.15,12.77,10.85.13,3.67-.69,7.68-1.21,11.19-.12.85-.23,1.66-.3,2.44-2.44.7-8,.92-8.86.95-1.3.05-2.09,3.52-2.56,7.05",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2094,119.77c-4.26,4-9.64,2.26-11.9,6.64L2081,127a5.89,5.89,0,0,0-3.65-1.19,6.9,6.9,0,0,0-2,3.68,19.77,19.77,0,0,1-3.28.45",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2071.3,318.21c-.27,5.4-.71,11.79-.85,17.2,20.25.49,17-.51,20.25-.51s7.14-.61,7.14-3.41c0-8.27-15.15-2-17.29-13.28",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2061.2,211.8c-1.15,12.69-9.17,105.09-9,106.48l16.09-.06",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2057.6,318.28c-.27,5.4-.71,10.79-.85,16.19,7.22.18,11.45.29,14.07.37",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2094.33,128.33c3,.26,8.89.89,8.89.89,4.39.66,8.34,6.89,11.85,21.39",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2094.59,123.27l9.25-.46s29.9,25.51,32.29,33.28c2.5,8.14-56.55,10.81-56.55,10.81",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070.45,147.21c5.35-4.09,42.75,2.48,50.75,5.2",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2108.4,133c1.38-1.48,1.62-1.31,2.53-3.06",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2071.59,145.8c-29.33,16.6-31.52,22.33-29.5,33.11,1.2,6.47,7,14.18,15.56,25.79",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2058.53,187.41c-2-3.3-3.75-6.5-4.14-8.58-.86-4.6,1.83-7.07,6.22-11.41",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2313.32,125.19c20.6,0,39.86-1.43,40.27-22.11.39-19.58-13-19.36-29.88-20.09,0-.67,8.4-28.69-47.83-26.23-15.74.69-32.22,4.41-33.13,22.13-14.94.33-30.25-1.15-32.8,17.15-3.55.54-19.56.87-20.27,11.78,0,0-3.58,18.18,19.84,18.18C2213.87,126,2307.18,125.19,2313.32,125.19Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bridge_Element",
    "data-name": "Bridge Element"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1574.45,483.24c-.1-23.2-1.36-189.14-.68-204.85,21.65-.11,91.43-2.93,102.25-2.81.64,43.43,1.36,87.08,1.37,130.63q0,23.71-.32,47.36,11.84-.17,23.65-.15c26.42,0,52.84.44,79.26.44,88.1,0,47.94-3.18,363.23-3.22,277.92,0,242.59-.41,314.76-.2",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1603.15 314.34 1620.07 315.87 1620.07 349.9 1603.16 349.91 1603.15 314.34",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1635.7,
    y: 391.97,
    width: 14.31,
    height: 35.13,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1847.23,496c-13.87-6.8-45.88-22.84-95.54-22.84-51.9,0-57.64,23.63-87.84,23.64-25.51,0-29-16.51-69.41-16.51-7.68,0-19.42,3.79-19.42,3.79-10.76,0-20.55.34-31.26.16-.18-5.17-.25-10.33-.25-15.49q0-6.53.14-13.05c-9.34.26-18.67.64-28,1.24-.36-7.37-.37-14.74-.66-22.1h-1.29c-13.14,0-26.26-.45-39.4-.71-.11,8.4-.16,16.81-.25,25.21-10.2.4-91.21-.05-101.41.26l-.41,139c-5.78.38-49.94,2.32-61.44,2.23,0,0-1.19-102-1-108.74,7.1,5.64,26,.11,31.06-.8-14.38-7.33-30.22-29.38-30.12-29.68,3.79,5.09,14.07,7.34,22.73,7.34a32.1,32.1,0,0,0,10.19-1.39c-17.37-9.49-27.43-26.15-36.26-43.14,7.54,6.79,17,7.88,26.82,7.88h.88c-18.09-8.3-31.63-27-33.84-47.09-2.2,20.11-20,39.21-38.11,47.51h.88c9.8,0,19.29-1.09,26.82-7.88-8.83,17-18.88,33.65-36.25,43.14a32.1,32.1,0,0,0,10.19,1.39c8.66,0,18.94-2.25,22.73-7.34.1.29-15.74,22.35-30.12,29.68a83.61,83.61,0,0,0,14.78,1.41c7.46,0,11.72-1.19,19.11-3.86.69,15.81-.14,91-.57,110.64l-85.65.48",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1847.34,452.92c0,7.53,0,15.05,0,22.58,0,13.64-.3,13.61.09,27.28,12.31.31,24.69.43,37,.43q10.55,0,21.06-.11c0-17.15,0-34.23.35-51.34",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090.85,450.89c0,7.53,0,17.05,0,24.58,0,13.64-.3,13.61.09,27.28,12.3.31,24.69.43,37,.43q10.55,0,21.05-.11c.06-17.15,0-34.23.36-51.33",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2309.59,451.87c0,7.52,0,16.05,0,23.57,0,13.64-.17,13.62,0,27.28,6.78.32,13.6.44,20.41.44q5.8,0,11.6-.11c0-17.15,0-34.23.19-51.34",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905.52,493.75c29.84-18.27,64.62-29.47,99.55-29.48,36.45,0,57.89,13.48,85.64,29.45",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2341.64,490.4c14.46-5.38,28.55-10.12,44-10.12,27.87,0,47.78,17.21,72.2,17.2,11.51,0,21-4.28,30.11-10.16",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2149,493.11c29.05-15,56.06-22.94,82.89-22.94,25.49,0,50.82,7.18,77.6,22.4",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2162.79,450.64q-.21,8.26-.21,16.54c0,6.73.1,12.46.27,19.18",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2174.68,450.64c.07,10.41.24,20.44.44,30.74",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2188.11,450.65q-.11,6.47-.1,12.93c0,5.38,0,7.95.13,13.29",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2201.18,450.66c0,7.51.08,15.41.08,22.92",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2213.87,450.68c-.13,7.56-.13,6.33,0,20.89",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2297.75,451c0,1.3,0,2.6,0,3.9,0,8.13-.43,19.82-.55,31.15",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2285.77,451c-.18,10.1-.33,19.19-.46,29.29",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2271.48,450.87c0,2.68,0,5.35,0,8q0,8.57.07,17.15",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2226.91,
    y1: 450.71,
    x2: 2226.7,
    y2: 469.48,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2240.15,
    y1: 450.76,
    x2: 2240.44,
    y2: 470.44,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2256.73,450.81c-.16,7.2-.27,14.4-.29,21.6",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2309.51,451.75c.71-17.64.72-36.29,1.3-53.92,1.92-.43,30.47-.21,30.47-.21s.93,43.21.44,57.6",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2319.06,397.59c-.31,5.9-.63,11.83-.63,17.72,0,5.72.51,21.88.51,32.1,0,1.25,0,2.51,0,3.76",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2333.27,397.58c-.68,17.91-.74,35.78-1,53.72",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2338.65 397.61 2338.82 385.6 2313.23 385.6 2313.24 397.56",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2313.23,385.17c1-6.89,7.05-9.27,12.8-9.27,5.5,0,12.26.59,12.79,9.7",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2327,371.29v3.9",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2103.85,450.77c.71-17.63.71-35.28,1.3-52.92,1.92-.43,30.47-.2,30.47-.2s.77,35.68.54,53",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2113.4,397.61c-.31,5.91-.12,41.61-.12,51.82",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2126.61,397.6c-.68,18,.25,34.77,0,52.72",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2132.99 397.63 2133.16 385.62 2107.57 385.63 2107.57 397.59",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2107.57,385.19c1-6.88,7-9.26,12.8-9.26,5.49,0,12.26.59,12.79,9.69",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2121.29,371.31v3.91",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Train"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2041.67,407.11c9.52,14.7,21.34,27.47,29.39,43.15",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2042,440.3q6.08.13,12.14.13c3.72,0,7.44,0,11.16-.08",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.39,408c18.69-.29,150.47-1,151.87-1-.34,15.45-.54,30.89-1.07,46.33",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2042.16,450.78q-.18-8.26-.17-16.53c0-9.21.13-18.41.27-27.63-11.29-.52-22.6-.71-33.93-.7-25.13,0-50.32.9-75.38.9-10.82,0-17.16-.2-33.79-.2-20.3,0-40.6.29-60.9.4q-.6,23.07-.77,46.15",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1829,421.11l9,.25",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828.54,441.35q4.1,0,8.17-.05h.89",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1988.67,440.29s-38.37.33-45.21-.07c-.1-6.73-.26-13.45-.26-20.19v-.42c15.68-.91,29.48-.95,45.17-1C1988.37,418.65,1988.68,440.24,1988.67,440.29Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850.16,452.35s.33-22.27.77-31.16c3.19-.14,18-.09,22.15.1,0,0-.15,28.74-.22,31",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1862.06,
    y1: 421.15,
    x2: 1861.03,
    y2: 452.32,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2002.11,449.39s.33-22.28.77-31.17c3.19-.13,18-.09,22.15.11,0,0-.15,28.74-.22,31",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2014.01,
    y1: 418.18,
    x2: 2012.98,
    y2: 449.35,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1931.58,440.71s-38.36.34-45.2-.06c-.11-6.73-.27-13.45-.27-20.19V420c15.68-.91,29.48-1,45.17-1C1931.28,419.08,1931.59,440.66,1931.58,440.71Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1778.31,444.48s-38.36.34-45.2-.06c-.11-6.74-.27-13.45-.27-20.19v-.42c15.68-.91,29.48-.95,45.17-1C1778,422.85,1778.32,444.43,1778.31,444.48Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.75,453.58s.33-22.27.78-31.16c3.18-.14,18-.09,22.14.11,0,0-.15,28.73-.22,31",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1803.65,
    y1: 422.38,
    x2: 1802.62,
    y2: 453.55,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.35,424.15c15-.83,28.42-.86,43.57-.87,0,0,.31,21.58.3,21.63s-34.84.3-44,0",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "sun"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672.28,4.44c-.49,0-1,0-1.47,0C640.28,4.42,619,31.67,619,55.8c0,19,12.38,53,54.54,53,34.22,0,50.59-23.23,50.59-54.38a49.63,49.63,0,0,0-9.26-29.68C705.85,12.16,687,4.84,672.28,4.44Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bike"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1304.96,
    cy: 861.34,
    r: 80.34,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1304.96,
    y1: 861.34,
    x2: 1378.76,
    y2: 714.55,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.34,744.24c-2.63.31-4,3.67-4,6.92s1.3,6.31,3.92,6.31,5.27-2.4,5.27-6.61c0-3.33-1.8-6.65-4.74-6.65Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.87,744c8.75,2.72,16.05,4.61,14.61,7.82-1.56,3.5-5.94,5.53-15.45,5.77",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1570.61,
    cy: 861.31,
    r: 80.34,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.45,753.06c-.28,5.68-.4,11.36-.4,17,0,32.12-4.08,59.07-3.44,91.22",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559.83,753.67c.18,8.1,8.25,88.31,8.7,107.59",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1464.88 840.3 1499.98 761.94 1570.61 861.31 1464.02 858.72",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364,746.75c8.65,14.77,32.74,51.16,78.9,70",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1466.14,824c1.76.43,3.55.82,5.35,1.2",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1350.95,
    y1: 773.17,
    x2: 1445.92,
    y2: 850.5,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.76,714.55c-43.58-10.93-23-3.86-64.28-13.86a56.85,56.85,0,0,0-1.35,10.59c0,27.19,31.74,32.69,48.89,37.43",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.16,703.19c.45,4.72,1,9.43,1.81,14.11.86,5.32,1.94,13.59,3.26,18.8",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.48,706.21c.36,4.86,1,9.64,1.73,14.39,1.08,6.59,3.11,15.53,4.77,22.08",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346,707.54c.12.77.24,1.54.37,2.31,1.88,11.53,4.21,25,6.71,36.5",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1362.1,711c.74,6.4,1.65,11.76,2.69,18.11.63,3.91,1.2,7.11,1.84,10.44",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.58,748c8-.06,15.55-.13,17.23-.13,3,0,7.67.23,7.67,2.9a3,3,0,0,1-.2,1,51.61,51.61,0,0,1-14.24,1.64c-5.09,0-10.22-.37-15.16-.37-5.64,0-11.89.56-17.86.62",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445.74,844.31c-11.29-21-23.52-44.43-23.52-66.75s34.21-41,45.65-41c5.31,0,8.65,3.25,11,7.55",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.82,858.84c5.16,5.26,16.44,8.39,21.7,13.89",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491,875.17c-9.74,9.18-18.51,20.05-27.19,23.28",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.78,866.79c-2,7.38-10.44,16.82-17,20",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dog_in_basket",
    "data-name": "Dog in basket"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1351.05,632.88c-1.48,6-5.12,12.86-9,12.32s-8.26-1.79-12.19-1.79c-6.94,0-9.57,6.28-9.57,13.15,0,1.26.06,2.51.09,3.79",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.4,660.49a11.4,11.4,0,0,0-3.15-.3c-3.67,0-9.07.59-11.59.6a3.62,3.62,0,0,0-.46,2c0,7.8,2.58,13.73,9.88,13.73,3.07,0,6.62-.7,10.3-.7a23.63,23.63,0,0,1,2.52.13c.06.3.11.61.15.92",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.05,676.9c-.51,3.45-2.07,18.25-2.16,26.48",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.48,632.59c.23,1.16,3.58,17.11,4.19,24.18.38,4.4-1.52,8.61-3.13,12.83",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.08,669.89a1.55,1.55,0,0,1,.47-.08c6.54,0,17,7,17,26.23a156.25,156.25,0,0,1-1.13,16.21",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.76,655.29c-1.17,0-1.49,2-1.49,3,0,2.12,1.64,3.56,2.83,3.56s2.17-1.55,2.17-3.15a3.23,3.23,0,0,0-3.49-3.42Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.91,655.72c.48,1.93,2.95,2.25,4.62,2.6",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.42,643.42c.6-4.56,2.56-9.23,4.54-13.22.23.47-.31-2.85,4.3,13.75",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1355.61,670c-6.12,8.63-18.14,13.56-28.43,14.47",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.78,676.32c8.51-2.45,17-4.62,25.24-8",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bike_Lady",
    "data-name": "Bike Lady"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1528.41,753.76c-7.38-7.88-17.94-15.59-29.36-15.59-9.21,0-56,12.86-56,63.91a376.06,376.06,0,0,0,3.86,49.95c6.73,50.07-41.45,33.23-41.45,46.29,0,2.87,6.68,5.71,15.24,5.71,9.73,0,40.65-.06,42.53-.93,1.31-.6-.28-16.48-.1-21.13,3.06-78.36,1-120.72,65.26-128.21",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.78,905c0,5.7,4.54,5.75,9.81,5.84,26.3.46,21.86-6.11,21.25-6.75",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.69,889.8c0,4.43,4.43,5.43,9.59,5.43,2.23,0,18.74,0,27.54-5.44",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.19,701.89c-16.58,36.65-14,24.83-26.66,51,9.19-7.15,19.93-15.84,32.22-15.84,6.22,0,8.81,4.81,14,4.81,5.53,0,15.58-4.18,23.21-4.18,17.06,0,20.71,18.79,37.38,18.79,0,0,33.13-3.36,47.35-13,9.92-6.73,35.34,4.47,36.58,4.47,11.68,0,25.68,5.78,56.37-13.41,0,0-2.7,2-17.69-7.22-16.09-9.9-30.76-31.28-58.29-31.27-3.36,0-62.25,11.8-76.36-55.21-1.46,16.19-9.42,17.52-16.69,17.52-4.83,0-9.54-3.26-12.67-10.48",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.71,655.7c-1.58-3.5-5.78-10.46-5.78-14.05a45.19,45.19,0,0,1,2-12.4c.92,5.53,4.41,8.77,9.55,10.3",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.65,727.74c-5,0-14.88-1.5-14.88-6.91a11.85,11.85,0,0,1,2-6.28c23.77-27.64,43.45-7,77.62-31.74,11.42-8.26,16.14-27.92,28.29-55,4.58-10.22,9.25-26.44,19.49-26.44,15.14,0,24,34.86,27.57,49.67",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.64,627.94c-24.07,63.08-44.59,76.55-58.08,78-36.28,4-46.82-1.81-58.91,21.77",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.34,717.46c9.18,3.18,27.81.68,27.81,6.22,0,2.16-5.83,2.73-7.39,2.73h-.11c-8.42-.19-17,.08-25.15-2.07",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.43,708.82c-3.26-2.89-3.17-9.67-5.59-9.67-4.43,0-6,8.26-6.61,13.77",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.41,691.75c22.74-34.7,69.79-14.52,82-60.34,2.78-10.44,3-25.69,17.64-24.51-.92,96.45-71.32,52.7-88.22,97.52",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1469.33,604c0-.21,21.09-5.79,26.93-8,.86,1.2,2.24,5.42,2.91,6.86-7.33,4.89-18.78,6.92-27.46,8.78C1471.65,611.12,1469.33,604.81,1469.33,604Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.43,541.74A107.93,107.93,0,0,0,1458,565.32c1.22-2.09,3-10,9.1-10,3,0,4.25,3,4.25,5.91,0,4.19-2.8,7.49-2.8,11.17,0,5.18,6.73,9.5,13.54,12.51,3.22-1.06,6.45-2.09,9.71-3.06,0-.46,0-.92,0-1.38,0-5.69,1.26-11.47,1.25-16.83,0-13.16-5.52-30.26-20.94-30.26-18.84,0-29,3.53-29,22.8,0,13.12,7,25.86,13.44,37.28",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.35,559c-19.51,6.59-31.32,4.63-31.32,9.77,0,3.53,2.85,7,6.62,7s7.5-3,7.49-9.88c0-.63,0-1.25-.09-1.87",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497.35,516.47a19.79,19.79,0,0,0-5.22-.78c-7.15,0-10.86,5.43-10.86,12.59,0,12.29,8.09,20.69,20.07,20.69,7.23,0,11.58-5,11.58-11.37a15.84,15.84,0,0,0-.57-4.17C1510.22,525.62,1505.22,518.66,1497.35,516.47Z",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.88,593.68c2.88-1,5.75-2,8.62-3a53.85,53.85,0,0,1,5.51,12.83",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1489.51,582.58a38.6,38.6,0,0,0,5.13,14",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497.07,597.53c6.94-2.26,14-6.83,19.52-6.83,12.4,0,19.21,12.17,34.8,12.17,12.21,0,21.28-5.54,36.8-5.55,15.21,0,26.89,5.76,37.29,18.44-10.16-6.16-15.58-7.24-22.28-7.24-18.81,0-36.22,11.57-55,11.58h-.08c-19.46,0-25.08-13.11-34.81-14.18",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Zakim_Bridge",
    "data-name": "Zakim Bridge"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M993,339.08,925.53,177.33C912.59,224,879.46,325,875.08,338.27c37.79.47,75.59.81,113.39.81,100.77,0,158.94-3.95,240.06-3.95,61.73,0,105.77,5.24,166,5.24,37,0,74-1,111-1.88l-57.91-196.08c.22-37.65.08-75.3.37-112.93.37,0,16.2,0,18.33.12.5,6.59.63,13.16.63,19.72,0,7.65-.18,15.3-.18,23,0,22.29,1.54,48.08,2.58,70.13l62,195.5q21.09-.42,42.19-.59",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.16,34.3c0-.88,0-1.76,0-2.64-.37,0-16.19,0-18.33.12-.49,6.59-.63,13.16-.63,19.73,0,7.65.19,15.29.19,23,0,22.3-1.55,48.08-2.58,72.13l-62.18,191",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.7,547.4l.09-211.66C713.42,335.85,782,337,850.66,338l58.86-193.37c-.22-36.76-.09-73.53-.36-110.29",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.34,93.49C822.12,176.18,752.56,255.9,672.11,335.84",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 890.81,
    y1: 31.78,
    x2: 915.17,
    y2: 4.42,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 916.17,
    y1: 4.42,
    x2: 936.84,
    y2: 30.55,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 896.45,
    y1: 133.82,
    x2: 711.89,
    y2: 336.14,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.34,115.09C830.88,189.83,764.58,264.72,693.53,336",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.5,338.65l92.4-196.06s2.45-86.3,4.44-114.22c4.92.29,17.79.8,22.7,1.11",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.37,338.82l68.28-163.67c13.88,50,50.93,162.4,50.93,162.4",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1459.85,91.31c52.31,57.51,118.68,123.31,181.72,185.18",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.54,310.77c16.9,16.56,33.3,32.65,48.83,48",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460.38,122.7c67.84,76.3,75.59,81.63,148.32,154.21",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460.11,106.2c49.51,52,109.1,112.88,165.81,170.8",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.8,329c11.48,11.76,22.66,23.23,33.4,34.28",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1432.04,
    y1: 84.67,
    x2: 1106.74,
    y2: 337.42,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1431.75,
    y1: 98.27,
    x2: 1131.6,
    y2: 336.57,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1431.5,
    y1: 112.31,
    x2: 1153.42,
    y2: 336.14,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 924.3,
    y1: 81.85,
    x2: 1250.56,
    y2: 335.35,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 924.64,
    y1: 95.7,
    x2: 1224.94,
    y2: 335.13,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "924.99 109.9 1206.4 335.41 1431.77 148.21",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "925.5 128.95 1179.66 334.96 1431.24 131.05",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.84,30.55c2,27.92-.55,114.22-.55,114.22l91.47,194.11",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.17,4.42l-7,27.24c4.91-.31,22.78-.81,27.7-1.11",
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1466.86,
    y1: 28.37,
    x2: 1445.51,
    y2: 1,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1445.51,
    y1: 1,
    x2: 1425.34,
    y2: 28.37,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1445.51,
    y1: 1,
    x2: 1448.53,
    y2: 28.24,
    fill: "none",
    stroke: "#030201",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyline);
export default __webpack_public_path__ + "static/media/skyline.b4305ed5b03a9d893a5aa97b59e1ed9f.svg";
export { ForwardRef as ReactComponent };